import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
import {WithChildren }from '../react18MigrationHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
  // children: React.ReactFragment
}

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
      {/* {children} */}
    </span>
  )
}

export {KTSVG}
